import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workItemCreatedSuccessfullyTitle: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-created-successfully-title',
		defaultMessage: 'Created {issueKey}',
		description: 'The heading for the issue created success flag',
	},
	workItemChangedStatusDescription: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-changed-status-description',
		defaultMessage: 'Created <Bold>{issueKey}</Bold> with <Bold>{statusName}</Bold> status',
		description: 'The description for the issue created success flag when the status has changed',
	},
	workItemHiddenDescription: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.work-item-hidden-description',
		defaultMessage:
			'<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all work items.',
		description: 'The description for the issue created success flag when the status has changed',
	},
	rerankingPromptDescription: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.reranking-prompt-description',
		defaultMessage:
			'Select <Bold>clear sorting</Bold> to create and reorder work in specific positions.',
		description: 'The description for the issue created success flag when prompting for reranking',
	},
	clearSorting: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.clear-sorting',
		defaultMessage: 'Clear sorting',
		description: 'The button text to clear sorting when reranking is prompted',
	},
	viewWorkItem: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.view-work-item',
		defaultMessage: 'View {issueKey}',
		description: 'The button text to view the created work item',
	},
	issueHiddenDescription: {
		id: 'issue-table-grouping-issue-create-utils.use-has-issue-create-field-changed.flag.success.issue-hidden-description',
		defaultMessage:
			'<Bold>{issueKey}</Bold> is hidden because a filter is applied. Clear the filter to see all issues.',
		description: 'The description for the issue created success flag when the status has changed',
	},
});
